import { Chart as ChartJS } from 'chart.js';

export type ChartDragging = ChartJS<'line'> & {
  isDragging?: boolean;
  dragPoint?: { x: number; y: number };
  clicked?: { x: number; topY: number; bottomY: number };
};

export const overviewColors = {
  product: '#F3A1B8',
  material: '#5467B2',
  future: '#19CEB8',
  marker: '#189AE3',
};

export const drawLine = (ctx: CanvasRenderingContext2D, x: number, y: number, endY: number, strokeStyle: string) => {
  ctx.beginPath();
  ctx.moveTo(x, y);
  ctx.lineTo(x, endY);
  ctx.lineWidth = 2;
  ctx.strokeStyle = strokeStyle;
  ctx.stroke();
};

export const drawDragIcon = (ctx: CanvasRenderingContext2D) => {
  // const dotsCount = 4;
  // const spacing = 3;
  // const dotRadius = 3;
  // const xStart = x - spacing - dotRadius;
  // const yStart = y - dotsCount * (spacing + dotRadius);

  const p = new Path2D(`mm15 5-1.41 1.41L18.17 11H2v2h16.17l-4.59 4.59L15 19l7-7z`);

  ctx.stroke(p);
  ctx.fill(p);
  ctx.stroke();
};

export const drawDragDots = (ctx: CanvasRenderingContext2D, x: number, y: number, strokeStyle: string) => {
  const dotsCount = 6;
  const dotRadius = 2;
  const spacing = dotRadius + 1;

  // Calculate starting positions for both columns
  const xLeft = x - dotRadius - 2;
  const xRight = x + dotRadius + 2;
  const yStart = y - dotsCount * spacing;

  for (let i = 0; i < dotsCount; i++) {
    const yDot = yStart + i * (spacing + 1);
    ctx.beginPath();
    ctx.lineWidth = 1;
    ctx.arc(xLeft, yDot, 1, 0, 2 * Math.PI);
    ctx.fillStyle = strokeStyle;
    ctx.fill();

    ctx.beginPath();
    ctx.arc(xRight, yDot, 1, 0, 2 * Math.PI, false);
    ctx.fillStyle = strokeStyle;
    ctx.fill();
  }
  const p = new Path2D(`mm15 5-1.41 1.41L18.17 11H2v2h16.17l-4.59 4.59L15 19l7-7z`);

  ctx.stroke(p);
  ctx.fill(p);
};

export const drawCircle = (ctx: CanvasRenderingContext2D, x: number, y: number, strokeStyle: string, radius = 5) => {
  ctx.beginPath();
  ctx.arc(x, y - radius, radius, 0, 2 * Math.PI, false);
  ctx.fillStyle = strokeStyle;
  ctx.fill();
  ctx.lineWidth = 2;
  ctx.strokeStyle = strokeStyle;
  ctx.stroke();
};

export const getRelativePosition = (event: MouseEvent) => {
  const rect = (event.target as HTMLCanvasElement).getBoundingClientRect();
  return {
    x: event.clientX - rect.left,
    y: event.clientY - rect.top,
  };
};

export const handleMouseDown = (chart: ChartDragging) => (event: MouseEvent) => {
  const { x, y } = getRelativePosition(event);
  //const minIndex = chart.config.options.plugins.drawLinePlugin?.minIndex;
  //chart.options.plugins.drawLinePlugin.minIndex
  //console.log('chart', chart);
  chart.isDragging = true;
  chart.dragPoint = { x, y };
};

export const handleMouseMove = (chart: ChartDragging) => (event: MouseEvent) => {
  if (chart.isDragging) {
    const { x, y } = getRelativePosition(event);

    chart.dragPoint = { x, y };
  }
};

export const handleMouseUp = (chart: ChartDragging) => () => {
  chart.isDragging = false;
};
